import type { DemoStore } from "./demoSupabase";

export const demoStore: DemoStore = { tables: {} };

/** Builds the seed on demand so ordinary visitors never download it. */
export const loadDemoData = async () => {
  const { buildEnrichmentDemoTables } = await import("./enrichment/seed");
  const { buildDemoFunctions } = await import("./enrichment/functions");
  demoStore.tables = buildEnrichmentDemoTables().tables;
  demoStore.functions = buildDemoFunctions(demoStore.tables);
};
